<template>
  <div id="header">
    <tvu-top-header
      projectName="Billing Service"
      :globalFunList="['account', 'headerTime']"
      :versionServiceNameList="['Billing Service']"
      :theme="theme"
      @callback="topHeaderCallback">

      <!--自定义项目名称区域 -->

      <template #top-header-project-name></template>

      <!-- 自定义版本号显示 -->
      <!-- <template #top-header-version>
        <div>支持自定义的版本号显示</div>
      </template> -->

      <!-- 自定义系统级别账号下拉的中间模块 -->
      <template #account-center-module>
        <div
          class="language commonLi"
          @click="changeLanguage">
          <span class="first-l-span">{{$t("home.language")}}</span>
          <span
            class="en"
            :class="{green:$i18n.locale=='en'}">EN</span>
          <span>/</span>
          <span
            class="cn"
            :class="{green:$i18n.locale=='zh'}">中</span>
        </div>

        <div
          class="language commonLi"
          @click="changeTheme">
          <span class="first-l-span">{{$t("home.theme")}}</span>
          <span
            class="en"
            :class="{green:theme=='dark'}">{{ $t('home.dark') }}</span>
          <span>/</span>
          <span
            class="cn"
            :class="{green:theme=='light'}">{{ $t('home.light') }}</span>
        </div>
      </template>

      <!-- 自定义头部中间模块 -->
      <template #top-header-middle>
        <el-dropdown
          trigger="click"
          placement="bottom"
          class="user-drop">
          <span>
            {{ handlePageName($route.name) }}
          </span>
          <el-dropdown-menu
            slot="dropdown"
            class="user-drop-menu">
            <el-dropdown-item
              v-for="page in pageList"
              :key="page"
              @click.native="goPage(page)">{{ handlePageName(page) }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>

      <!-- 自定义整个服务右侧的私有功能（可以包括或者不包括多账号ui， 多账号提供默认样式） -->
      <template #right-app-module>
        <!-- <div v-if="role == 3" class="item-fun" @click="goWhitePage">
          <svg class="white-list-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1551 22.0524C14.394 22.332 14.7668 22.5 15.1474 22.5C15.3184 22.5011 15.4876 22.4653 15.6435 22.395L15.6724 22.3818L18.342 20.82L18.3682 20.8003C18.8381 20.4538 19.0179 19.7726 18.7856 19.22C18.783 19.2148 18.5468 18.6386 18.5468 18.1136C18.5468 16.5189 19.7726 15.2222 21.2768 15.2222H21.3686C21.807 15.2314 22.1666 14.8245 22.2795 14.1879C22.29 14.1381 22.5 12.9476 22.5 12.0079C22.5 11.1237 22.3119 10.013 22.284 9.8483L22.2808 9.82914C22.1666 9.19389 21.807 8.78571 21.3699 8.79621H21.2781C19.7726 8.79621 18.5481 7.49946 18.5481 5.90478C18.5481 5.42751 18.7433 4.90793 18.7788 4.81346L18.7789 4.81334C18.7824 4.80397 18.7843 4.79882 18.7843 4.79834C19.0179 4.24447 18.8381 3.5646 18.3682 3.21679L18.342 3.19841L15.717 1.65361L15.6894 1.64048C15.5346 1.56961 15.3639 1.53286 15.1828 1.53286C14.8088 1.53286 14.4412 1.69036 14.2011 1.95548C13.8808 2.30592 12.8702 3.21548 12.0551 3.21548C11.2322 3.21548 10.215 2.28754 9.89344 1.93054C9.65194 1.66148 9.28181 1.50004 8.90513 1.50004C8.73338 1.49858 8.56331 1.53394 8.40637 1.60373L8.3775 1.61686L5.65931 3.19841L5.63306 3.2181C5.16188 3.56329 4.98206 4.24447 5.21438 4.79703C5.217 4.80228 5.45325 5.37978 5.45325 5.90478C5.45325 7.49946 4.22738 8.79621 2.72325 8.79621H2.63138C2.19169 8.78571 1.83338 9.19389 1.71919 9.83045C1.71 9.87901 1.5 11.0708 1.5 12.0092C1.5 12.9026 1.69151 14.0256 1.71669 14.1732L1.71919 14.1879C1.83206 14.8153 2.1825 15.2222 2.61431 15.2222H2.63006H2.72194C4.22738 15.2222 5.45194 16.5189 5.45194 18.1136C5.45194 18.5968 5.25184 19.1233 5.21995 19.2072C5.21882 19.2102 5.21789 19.2126 5.2172 19.2145C5.21621 19.2171 5.21569 19.2185 5.21569 19.2187C4.98338 19.7726 5.16056 20.4525 5.62913 20.8003L5.65538 20.8187L8.23181 22.3438L8.25806 22.3569C8.41688 22.43 8.58986 22.4672 8.76469 22.4658C9.14269 22.4658 9.5115 22.3018 9.75037 22.0262C10.0522 21.6784 11.1036 20.6874 11.9449 20.6874C12.7928 20.6874 13.827 21.6718 14.1551 22.0524ZM15.0461 21.19C15.0179 21.1897 14.9903 21.182 14.966 21.1677C14.9214 21.1152 14.5631 20.7057 14.0473 20.2962C13.2768 19.6859 12.5445 19.3762 11.8698 19.3762C11.2005 19.3762 10.4733 19.6807 9.70815 20.2792C9.19496 20.6808 8.83927 21.0824 8.79333 21.1349C8.78283 21.1428 8.75002 21.1559 8.71458 21.1559H8.70933L6.32321 19.7318C6.38096 19.5862 6.65658 18.8656 6.65658 18.1135C6.65658 15.8705 5.00283 14.033 2.92908 13.9175C2.8989 13.7416 2.73615 12.752 2.73615 12.0091C2.73615 11.2663 2.8989 10.2766 2.92908 10.0994C5.00283 9.98526 6.65658 8.14645 6.65658 5.90471C6.65658 5.15658 6.3849 4.43865 6.32452 4.28771L8.84583 2.80984C8.88133 2.80878 8.9164 2.81789 8.9469 2.83609C9.22436 3.13572 9.52738 3.41063 9.85252 3.65771C10.6085 4.23259 11.3225 4.52396 11.9788 4.52396C12.6271 4.52396 13.3372 4.23915 14.0866 3.67478C14.5587 3.32108 14.8958 2.96625 14.9748 2.88306L14.9883 2.8689C15.0161 2.85221 15.0478 2.84315 15.0802 2.84265H15.0907L17.5241 4.2864C17.465 4.43471 17.192 5.15396 17.192 5.90471C17.192 8.14645 18.8458 9.98526 20.9195 10.0994C20.9497 10.2766 21.1111 11.2663 21.1111 12.0091C21.1111 12.752 20.9497 13.7416 20.9195 13.9175C18.8458 14.0317 17.192 15.8705 17.192 18.1135C17.192 18.863 17.465 19.5822 17.5241 19.7305L15.05 21.19H15.0461ZM11.9998 15.9375C9.82894 15.9375 8.06232 14.1709 8.06232 12C8.06232 9.82914 9.82894 8.06252 11.9998 8.06252C14.1707 8.06252 15.9373 9.82914 15.9373 12C15.9373 14.1709 14.1707 15.9375 11.9998 15.9375ZM9.40155 12C9.40155 10.5668 10.567 9.40127 12.0003 9.40127C13.4335 9.40127 14.599 10.5668 14.599 12C14.599 13.4333 13.4322 14.5988 12.0003 14.5988C10.567 14.5988 9.40155 13.4333 9.40155 12Z" fill="currentColor"/>
          </svg>
        </div> -->

        <!-- <div class="item-fun">2</div>
        <div class="item-fun">3</div>
        <div class="item-fun">4</div> -->
      </template>

      <!-- 如使用多账号默认样式，（多账号属于项目私有功能）也可支持自定义的多账号下拉样式 -->
      <!-- <template #multi-account-dropMenu-module>可自定义下拉模块/选择默认列表样式</template> -->

    </tvu-top-header>
    <!-- <div class="left">
      <div class="img-wrap">
        <img src="../../assets/image/emblem-green.png" alt="" />
      </div>
      <div class="title">Billing</div>
    </div>
    <div class="right">
      <el-dropdown trigger="click" placement="bottom" class="user-drop">
          <div class="user-name" :style="{'background-color': randomColor(email)}">
            {{email.substr(0,1)}}
          </div>
          <el-dropdown-menu slot="dropdown" class="user-drop-menu">
            <el-dropdown-item>{{email}}</el-dropdown-item>
            <el-dropdown-item class="divided-bottom" @click.native="logOut()">LogOut</el-dropdown-item>
          </el-dropdown-menu>
      </el-dropdown>
    </div> -->
  </div>
</template>

<script>
import Helper from '@/common/helper'
import jsCookie from 'js-cookie'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      showUserMsg: false,
      currentLang: 'en',
      langs: ['en', 'zh'],
      env: Helper.getEnv()
    }
  },
  created () {
    const lang = jsCookie.get('userLanguage')
    if (this.langs.includes(lang)) {
      this.$i18n.locale = lang
    }
  },
  methods: {
    handlePageName (page) {
      if (page == 'TokenManage') return 'Token Billing management'
      if (page == 'GoWhitelist') return 'Go Whitelist'
      if (page == 'DashBoardContnet') return 'DashBoard'
      if (page == 'Subscriptions') return 'Subscriptions'
      if (page == 'TokenCheckGroups') return 'Token Check Groups'
      return page
    },
    goPage (page) {
      this.$router.push({
        name: page == 'DashBoard' ? 'DashBoardContnet' : page
      })
    },
    changeLanguage () {
      const lang = this.$i18n.locale == 'en' ? 'zh' : 'en'
      this.$i18n.locale = lang
      jsCookie.set('userLanguage', lang, {
        path: '/',
        domain: '.tvunetworks.com'
      })
    },
    changeTheme () {
      const theme = this.theme == 'dark' ? 'light' : 'dark'

      jsCookie.set('theme', theme, {
        path: '/',
        domain: '.tvunetworks.com'
      })
      window.document.body.classList.replace(this.theme, theme)
      this.$store.commit('saveTheme', theme)
    },
    topHeaderCallback (params) {
      if (params.type == 'signOut') {
        this.logOut()
      }
    },
    randomColor (name) {
      let str = ''
      for (let i = 0; i < name.length; i++) {
        str += parseInt(name[i].charCodeAt(0), 10).toString(16)
      }
      return '#0c' + str.slice(1, 2)
    },
    logOut () {
      const url = '/route-billing/billing-service/user/logout?accessToken='
      this.$axios.get(url).then((res) => {
        if (res.data.errorCode == '0x0') {
          window.location.replace(this.logOutUrl)
        }
      })
    }
  },
  computed: {
    ...mapState({
      email: store => store.userInfo.email,
      logOutUrl: store => store.initMsg.logOutUrl,
      theme: 'theme',
      accessBillingInternal: 'accessBillingInternal'
    }),
    pageList () {
      let pageList = ['DashBoard']
      if (this.accessBillingInternal) {
        // , 'TokenManage' 合并到whitelist
        pageList.push('SKU', 'WhiteList', 'GoWhitelist', 'TokenUsage', 'Subscriptions', 'TokenCheckGroups')
      } else if (!this.env.includes('prod')) {
        pageList.push('TokenUsage')
      }
      return pageList
    }
  }
}
</script>

<style lang="less" scoped>
#header {
  width: 100%;
  height: 64px;
  background: #121212;
  display: flex;
  justify-content: space-between;

  .left {
    margin-left: 100px;
    display: flex;
    height: 100%;
    align-items: center;

    .img-wrap {
      width: 32px;
      height: 32px;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .title {
      color: #DBDBDB;
    }
  }

  .right {
    width: 100px;
    margin-right: 100px;
    height: 100%;

    .user-name {
      color: #fff;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      line-height: 42px;
      margin-top: 11px;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .item-fun {
    cursor: pointer;
    svg {
      vertical-align: middle;
    }
  }
  .white-list-icon {
    color: var(--content-table-color);
  }

  ::v-deep #tvu-top-header {
    width: 100%;

    .container {
      width: 28px;
    }
    .user-drop {
      float: left;
      color: #33AB4F;
      font-weight: 700;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.tvu-topbar-account-popover.el-popover {
  .language {
    text-align: right;
    cursor: pointer;
    margin-bottom: 10px;
    .first-l-span {
      float: left;
    }
    .green {
      color: rgba(86, 175, 49, 1) !important;
    }
    span {
      font-weight: 500;
    }
    span:first-child {
      margin-right: 30px;
      font-size: 14px;
    }
    span:nth-child(2),
    span:nth-child(3),
    span:nth-child(4) {
      font-size: 12px;
      color: rgba(102, 102, 102, 1);
    }
  }
}
.user-drop-menu.el-dropdown-menu {
  background: var(--datepicker-bg) !important;
  border: none;
  top: 45px !important;
  width: 210px;
  li {
    color: var(--text-color-01);
    &.guide {
      font-weight: 600;
      text-decoration: underline;
    }
  }

  .el-dropdown-menu__item {
    line-height: 30px !important;
  }
  .el-dropdown-menu__item--divided:before {
    display: none;
  }
  .el-dropdown-menu__item--divided {
    border-top: 1px solid rgba(255, 255, 255, 0.25);
  }
  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: var(--datepicker-bg);
  }
  .popper__arrow {
    display: none;
  }
}
</style>
